import React from 'react';

const Carret: React.FC<{ color?: string }> = ({ color = '#F2F2F2' }) => {
  return (
    <svg
      width="12"
      height="8"
      viewBox="0 0 12 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.91996 7.29333L5.99996 3.22222L10.08 7.29333L11.3333 6.04L5.99996 0.706668L0.666626 6.04L1.91996 7.29333Z"
        fill={color}
      />
    </svg>
  );
};

export default Carret;
